import type { CardTag } from '@my-fullstack-app/itinerary-types';
import { colors } from '../theme/colors';
import type { IconName } from '../primitives/Icon';

export interface TagConfig {
  color: string;
  // IconName (not string) so the compiler enforces these are real registry
  // icons — a missing one crashes at the <Icon> render rather than tofu.
  icon: IconName;
  label: string;
}

export const TAG_CONFIG: Record<CardTag, TagConfig> = {
  important: { color: colors.accentCerulean, icon: 'star', label: 'Important' },
  'reach-goal': { color: colors.accentGreen, icon: 'help', label: 'Reach goal' },
  'missing-info': { color: colors.accentOrange, icon: 'warning', label: 'Missing info' },
};

const TAG_CYCLE: (CardTag | undefined)[] = [undefined, 'important', 'reach-goal', 'missing-info'];

/** Returns the next tag in the cycle: none -> important -> reach-goal -> missing-info -> none */
export function nextTag(current: CardTag | undefined): CardTag | undefined {
  const idx = TAG_CYCLE.indexOf(current);
  return TAG_CYCLE[(idx + 1) % TAG_CYCLE.length];
}
